import { AmountRouteImport } from './Import'
const { RoutesMap, PaymentTransactionList } = AmountRouteImport

const AmountRoute = () => {
    return [
        {
            path: RoutesMap.PAYMENT_HISTORY_LIST.path,
            element: <PaymentTransactionList />
        },
    ]
}

export default AmountRoute
